import {Jogging} from "./Jogging";
import {SoundEffect} from "../common/SoundEffect";

const LEVELS = [
  {count:0,seconds:10},
  {count:7,seconds:9},
  {count:8,seconds:8},
  {count:8,seconds:7.58},
  {count:9,seconds:7.2},
  {count:9,seconds:6.86},
  {count:10,seconds:6.55},
  {count:10,seconds:6.26},
  {count:11,seconds:6},
  {count:11,seconds:5.76},
  {count:11,seconds:5.54},
  {count:12,seconds:5.33},
  {count:12,seconds:5.14},
  {count:13,seconds:4.97},
  {count:13,seconds:4.8},
  {count:13,seconds:4.65},
  {count:14,seconds:4.5},
  {count:14,seconds:4.36},
  {count:15,seconds:4.24},
  {count:15,seconds:4.11},
  {count:16,seconds:4},
  {count:16,seconds:3.89},
]

export class ShuttleRun extends Jogging {
  constructor() {
    super()
    this.missCount = 0
    this.currentLevel = 0
    this.currentLevelData = LEVELS[this.currentLevel]
    this.remainDist = 0
    // this.lastLevelDist = 0
    this.currentLoop = 0
    this.status = 'init'
    this.ci = null
    this.initSound()

    this.goNextLevel()
  }

  getCurrentLevelData() {
    return LEVELS[this.currentLevel]
  }

  goNextLoop() {
    this.status = 'run'
    this.remainDist = 20.0
    // this.lastLevelDist = this.score
    this.currentLevelData = LEVELS[this.currentLevel]
    this.soundInterval = 1000 * this.currentLevelData.seconds / this.soundEffects.length

    this.soundCount = 0
    this.ci = setInterval(()=> {
      this.soundEffects[this.soundCount].play()
      this.soundCount++
      if(this.soundCount === this.soundEffects.length) {
        this.onTimeLimit()
      }
    },this.soundInterval)
  }

  goNextLevel() {
    this.currentLevel++
    this.currentLoop = 0
    if (this.ci) {
      clearInterval(this.ci)
      this.ci = null
    }

    this.goNextLoop()
  }

  onTimeLimit() {
    if (this.ci) {
      clearInterval(this.ci)
      this.ci = null
    }
    if (this.status === 'run') {
      this.missCount++
      if (this.missCount === 2) {
        this.finish()
        return
      }
    }
    this.currentLoop++
    if (this.currentLoop === this.currentLevelData.count) {
      this.goNextLevel()
    } else {
      this.goNextLoop()
    }
  }

  finish() {
    this.status = 'finish'
  }

  initSound() {
    const files = ['c1', 'd1', 'e1', 'f1', 'g1', 'a1', 'b1', 'c2' ]
    this.soundEffects = files.map(file => new SoundEffect(file))
  }

  mainLoop({ pose, hands }) {
    super.mainLoop({ pose, hands })
  }

  renderCamera(ctx, { pose, hands }) {
    super.renderCamera(ctx, { pose, hands })

    if (this.status !== 'run') return

    this.remainDist -= this.scoreDiff
    if (this.remainDist <= 0) {
      this.remainDist = 0
      this.status = 'wait'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/game/ShuttleRun.js